export const API_BASE_URL = "https://photo-gallery-one-rho.vercel.app/api";
export const IMAGES_URL = `${API_BASE_URL}/images`;
export const UPLOAD_URL = `${IMAGES_URL}/upload`;
